export const ACTIVE = 'active';
export const DISABLED = 'disabled';
export const HIDDEN = 'hidden';
export const LOADING = 'loading';
export const NO_HEIGHT = 'no_height';

const COMMON_CLASSES = { ACTIVE, DISABLED, HIDDEN, LOADING };
export default COMMON_CLASSES;
